import React, { useState } from 'react';
import classNames from 'classnames';
import CustomModal from '../Modal';

import Button from '../elements/Button';
import { SectionProps } from '../../utils/SectionProps';
import Donation from '../Donation';

const propTypes = {
  ...SectionProps.types,
};

const defaultProps = {
  ...SectionProps.defaults,
};

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <section {...props} className={outerClasses}>
      <div className='container-sm'>
        <div className={innerClasses}>
          <div className='hero-content'>
            <h1
              className='mt-0 mb-16 reveal-from-bottom'
              data-reveal-delay='200'
            >
              Pay Your Tuition{'  '}
              <span className='text-color-primary'>Foundation</span>
            </h1>
            <div className='container-xs'>
              <p
                className='m-0 mb-32 reveal-from-bottom'
                data-reveal-delay='400'
              >
                The PYT Foundation creates custom solutions that impact
                communities in the areas of education, health, finance, housing,
                professional development, and immigration. By creating and
                promoting solutions using technology to empower underserved
                communities and driving forward positive socioeconomic change.
              </p>
            </div>
            {/* Temporarily commenting out the Get Started button which was requested by Sonny */}
            {/*<Button
              className='button button-primary button-wide-mobile button-sm'
              onClick={handleOpen}
            >
              Get started
            </Button>*/}
            <Button
              className='button button-primary button-wide-mobile button-sm'
              onClick={handleOpen}
              style={{ 'font-family': 'sans-serif' }}
            >
              Donate Here
            </Button>
            <CustomModal isOpen={open} handleClose={handleClose}>
              <Donation />
            </CustomModal>
          </div>
        </div>
      </div>
      <div
        style={{
          width: '894px',
          height: '504px',
          marginBottom: '100px',
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
        className='hero-figure reveal-from-bottom illustration-element-01'
        data-reveal-value='20px'
        data-reveal-delay='800'
      >
        <video muted autoPlay loop>
          <source src={require('./../../assets/images/video.mp4')} />
        </video>
      </div>
    </section>
  );
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
